import {useState,ChangeEvent} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useCreateCardMutation } from '../../features/cards/api/cards-api';


const CardsAdd = () => {

    const [name, setName] = useState('');
    const [imageBase64, setImageBase64] = useState<string | undefined>();
    const [imageContentType, setImageContentType] = useState<string | undefined>();
    const [imageExt, setImageExt] = useState<string | undefined>();
    const [
        createCard,
        { isLoading, error, isSuccess, isError, data, reset },
    ] = useCreateCardMutation();

    const convertToBase64 = (file: File) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleFileUpload = async (e: ChangeEvent) => {
        const files = (e.target as HTMLInputElement).files;
        if (files) {
            const file = files[0] as unknown as File;
            const base64 = await convertToBase64(file);
            // @ts-ignore
            setImageBase64(base64);
            setImageContentType(file.type);
            setImageExt(file.name.split('.')[file.name.split('.').length - 1]);
        }
    };

    const submit = () => {
        if (imageExt!== undefined && imageBase64 !== undefined && imageContentType !== undefined) {
            createCard({
                name,
                imageExt,
                imageBase64: imageBase64.split(',')[1],
                imageContentType,
            });
        }
    };

    const resetSuccess = ()=>  {
        reset();
        setName('');
        setImageBase64(undefined);
        setImageExt(undefined);
        setImageContentType(undefined);
    };

    if (isError) {
        return <>
            <div>
                Error!
            </div>
            <div>
                <Button variant="contained" onClick={reset}>
                    Reset
                </Button>
            </div>
        </>;
    }

    if (isSuccess && data) {
        return <>
            <div>
                Card "{data.name}" has been added!.
            </div>
            <div>
                <Button variant="contained" onClick={resetSuccess}>
                    OK
                </Button>
            </div>
        </>;
    }

    if (isLoading) {
        return <CircularProgress />;
    }

    return (
        <>
            <Stack
                component="form"
                sx={{ width: '25ch' }}
                spacing={2}
                noValidate
                autoComplete="off"
            >
                <TextField
                    id="nameInput"
                    defaultValue=""
                    size="small"
                    label="Name"
                    value={name}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setName(event.target.value);
                    }}
                />

                <input
                    type="file"
                    name="myFile"
                    accept=".jpeg, .png, .jpg"
                    onChange={(e) => handleFileUpload(e)}
                />
            </Stack>
            {imageBase64 && <>
                <img src={imageBase64} style={{ maxWidth:'90%', margin:'32px' }} />
                {name.length > 0 &&
                <Button variant="contained" onClick={submit}>
                    Create card
                </Button>}
            </>}
        </>
    );
};

export default CardsAdd;